import {OfferType} from "../../types/OfferType";
import {getOfferTypeNameCapital} from "../OfferType";

export interface IRecommendedPropertyHeaderConfig {
    offerName: string;
    rooms: number;
    area: number;
}

interface IDistanceFromRegion {
    center: boolean;
    distance: number;
    region: string;
}

export const getPropertyLocation = (type: OfferType, address: string) => {
    return `${getOfferTypeNameCapital(type)} ${address}`;
};

export const getPropertyDistance = (distanceFromRegion: IDistanceFromRegion | undefined) => {
    if (!distanceFromRegion) {
        return "";
    }

    const {center, distance, region} = distanceFromRegion;

    if (center) {
        return `${distance} km od centrum ${region}`;
    } else {
        return `${distance} km od ${region}`;
    }
};
import {OfferType} from "../../types/OfferType";
import {getOfferTypeNameCapital} from "../OfferType";

export interface IRecommendedPropertyHeaderConfig {
    offerName: string;
    rooms: number;
    area: number;
}

interface IDistanceFromRegion {
    center: boolean;
    distance: number;
    region: string;
}

export const getPropertyLocation = (type: OfferType, address: string) => {
    return `${getOfferTypeNameCapital(type)} ${address}`;
};

export const getPropertyDistance = (distanceFromRegion: IDistanceFromRegion | undefined) => {
    if (!distanceFromRegion) {
        return "";
    }

    const {center, distance, region} = distanceFromRegion;

    if (center) {
        return `${distance} km od centrum ${region}`;
    } else {
        return `${distance} km od ${region}`;
    }
};
